let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("44xD1")).then(() => parcelRequire('9hAXc'));